import type { ErrorReport } from './error-report';
import type { ErrorReporter } from './error-reporter';

/**
 * Adaptador por defecto: un único console.error estructurado con prefijo estable,
 * fácil de filtrar en DevTools y de reemplazar por una plataforma real (ver
 * docs/decisions/LIBRARY-DECISIONS.md).
 */
export class ConsoleErrorReporter implements ErrorReporter {
  report(report: ErrorReport): void {
    console.error('[observabilidad]', report);
  }
}
